import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import LocationSearchErrorMessage from './presentionalComponents/LocationSearchErrorMessage';
import LocationFoundBlock from './presentionalComponents/LocationFoundBlock';
import LocationSearchBlock from './LocationSearchBlock';
import { getTranslation } from '../../translations/translations';

import { removeAllProductDeliveriesSearchAndAllPlaceSpecificAvailabilities } from '../../reduck/listingPagePages.reduck';
import { setGeolocationSearchFailedErrorMessage } from '../../reduck/listingPageLocationSearchSetup.reduck';
import { getActiveListingPage, getActiveLocationName } from '../../reduck/selectors';

const Wrapper = styled.div`
  padding: 10px 20px;
  margin-bottom: 10px;
  background-color: #f0f6eb;

  position: relative;
  max-height: 300px;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    .dc-location-block-filter-block {
      margin-top: 20px;
    }
  }

  @media ${({ theme }) => theme.breakpoints.touch} {
    .dc-location-block-filter-block {
      margin: 20px 18px 10px 18px;
    }
  }
`;
class LocationBlock extends PureComponent {
  render() {
    const {
      name,
      geolocationSearchFailedErrorMessage,
      deliveriesSearchErrorMessage,
      currentFoundLocationName,
      searchGeolocationPending,
      searchLocationPending,
      pendingProductsRequest,
      isMobile,
      onLinkClick
    } = this.props;

    const classNames = ['dc-location-block'];

    classNames.push(
      name === 'above product listing'
        ? 'dc-location-block-above-product-listing'
        : 'dc-location-block-filter-block'
    );

    if (geolocationSearchFailedErrorMessage || deliveriesSearchErrorMessage) {
      // error message when an error occurs
      return (
        <Wrapper className={classNames.join(' ')}>
          <LocationSearchErrorMessage
            errorMessageLabel={geolocationSearchFailedErrorMessage || deliveriesSearchErrorMessage}
            linkLabel={getTranslation('searchAgainLink')}
            linkDisabled={pendingProductsRequest}
            onLinkClick={(e) => {
              e.preventDefault();
              onLinkClick();
            }}
          />
        </Wrapper>
      );
    }
    
    if (currentFoundLocationName && !searchLocationPending && !searchGeolocationPending) {
      // location found component -
      // displayed only when location found AND is not searchLocationPending or searchGeolocationPending
      return (
        <Wrapper className={classNames.join(' ')}>
          <LocationFoundBlock
            locationFoundLabel={
              name === 'above product listing'
                ? getTranslation('locationFoundTopSearchLabel')
                : getTranslation('locationFoundFilterSearchLabel')
            }
            locationName={currentFoundLocationName}
            linkLabel={getTranslation('changeLocationLink')}
            linkDisabled={pendingProductsRequest}
            onLinkClick={(e) => {
              e.preventDefault();
              onLinkClick();
            }}
            orientation={name === 'above product listing' && !isMobile ? 'horizontal' : 'vertical'}
          />
        </Wrapper>
      );
    }
    // search input with/without geolocate
    return (
      <Wrapper className={classNames.join(' ')}>
        <LocationSearchBlock name={name} />
      </Wrapper>
    );
  }
}

LocationBlock.propTypes = {
  // DON'T CHANGE THE VALUES of the following prop, the format is due to analytics
  name: PropTypes.oneOf([
    'above product listing',
    'filter block'
  ]).isRequired,
  geolocationSearchFailedErrorMessage: PropTypes.string.isRequired,
  deliveriesSearchErrorMessage: PropTypes.string.isRequired,
  searchGeolocationPending: PropTypes.bool.isRequired,
  searchLocationPending: PropTypes.bool.isRequired,
  pendingProductsRequest: PropTypes.bool.isRequired,
  currentFoundLocationName: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  onLinkClick: PropTypes.func
};

LocationBlock.defaultProps = {
  currentFoundLocationName: null,
  onLinkClick: () => {}
};

function mapStateToProps(state) {
  return {
    geolocationSearchFailedErrorMessage: state.listingPage.locationSearchSetup.geolocationSearchFailedErrorMessage,
    deliveriesSearchErrorMessage: getActiveListingPage(state).productsDeliveriesSearch.errorMessage,
    searchGeolocationPending: state.listingPage.locationSearchSetup.searchingGeolocation,
    searchLocationPending: getActiveListingPage(state).productsDeliveriesSearch.searchPending,
    pendingProductsRequest: state.listingPage.commonData.xhrStatus.pendingProductsRequest,
    currentFoundLocationName: getActiveLocationName(state),
    isMobile: state.listingPage.browser
      ? state.listingPage.browser.device.deviceType === 'mobile'
      : false
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLinkClick: () => {
      dispatch(removeAllProductDeliveriesSearchAndAllPlaceSpecificAvailabilities());
      dispatch(setGeolocationSearchFailedErrorMessage(''));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationBlock);
